import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const baseUrl = "https://file.aurobilcars.com/api";

// api

export async function getAllImages(chassis) {
  const response = await axios.get(`${baseUrl}/images/${chassis}`);
  return response;
}

export async function uploadImage(data) {
  const response = await axios.post(`${baseUrl}/upload`, data);
  return response;
}

export async function deleteImageByChassis(chassis) {
  const response = await axios.delete(`${baseUrl}/delete/${chassis}`);
  return response;
}

export async function deleteImageByUrl(url) {
  const data = { url };
  const response = await axios.delete(`${baseUrl}/url/delete`, { data });
  return response;
}

export async function deleteImageByUrls(urls) {
  const data = { urls };
  const response = await axios.delete(`${baseUrl}/urls/delete`, { data });
  return response;
}

// hooks
export function useGetAllImagesQuery({ query, options = {}, key = "" }) {
  const {
    data,
    isPending: loading,
    ...rest
  } = useQuery({
    queryKey: [`getAllCarInfo-${query ?? ""}${key ? "-" + key : ""}`],
    queryFn: () => getAllImages(query),
    ...options
  });
  const newData = data?.data?.images ?? [];
  return { data: newData, loading, ...rest };
}

// functions

export function extractChassisFromImageUrl(url) {
  try {
    // Split the URL by '/'
    var parts = url.split("/");

    // Get the last part of the URL
    var lastPart = parts[parts.length - 1];

    // Split the last part by '-'
    var subparts = lastPart.split("-");

    // Extract the desired result
    var result = subparts[subparts.length - 2] + "-" + subparts[subparts.length - 1].split(".")[0];

    return result;
  } catch (error) {
    console.error("Error extracting result:", error.message);
    return null; // Return null if an error occurs
  }
}

export function imgUrl(image) {
  if (typeof image === "object" && image?.type) {
    return URL.createObjectURL(image);
  }
  return image;
}

export function filterImgFiles(images) {
  if (images?.length) {
    return images.filter((item) => typeof item === "object" && item?.type);
  }
  return [];
}

export function resizeImage(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // Set canvas size to 1600x1200
        canvas.width = 1600;
        canvas.height = 1200;

        // Fill canvas with white color
        ctx.fillStyle = "#ffffff"; // white color
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Calculate dimensions for resizing
        const widthRatio = 1600 / img.width;
        const heightRatio = 1200 / img.height;
        const ratio = Math.min(widthRatio, heightRatio);
        const newWidth = img.width * ratio;
        const newHeight = img.height * ratio;

        // Calculate position to center the image
        const x = (canvas.width - newWidth) / 2;
        const y = (canvas.height - newHeight) / 2;

        // Draw image on canvas
        ctx.drawImage(img, x, y, newWidth, newHeight);

        // Convert canvas to Blob
        canvas.toBlob((blob) => {
          const resizedFile = new File([blob], file.name, { type: file.type });
          resolve(resizedFile);
        }, file.type);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}
